<div id="icp-optimization-chart">
  <div id="profile-completed-chart"></div>
</div>
